// src/services/relatoDoPush.js -- conta ao servidor por que o navegador nao assinou.
//
// Por que existe. `assinarWebPushSeAutorizado` devolve `{assinou, motivo}` e
// ninguem consumia esse retorno: o aviso ia para `console.warn`, ou seja, morria
// no navegador da pessoa. Em 12/09/2026 isso custou dois dias -- o painel do
// Socios nao registrou uma unica assinatura e nao havia como saber se era falta
// de permissao, falta de service worker ou erro, porque o servidor nunca ficava
// sabendo. Com isto, um dia de uso ja da a distribuicao dos motivos.
//
// Exemplo:
//   assinarWebPushSeAutorizado(api, deviceId).then((r) => relatarSeNaoAssinou(api, r));

const ROTA = '/notification/api/webpush-diagnostico/';

/**
 * Manda o motivo quando a assinatura NAO aconteceu. Silencioso em caso de
 * sucesso, e nunca rejeita: diagnostico nao pode quebrar quem esta diagnosticando.
 */
export function relatarSeNaoAssinou(http, resultado, origem = 'socio') {
  if (!resultado || resultado.assinou || !resultado.motivo) return Promise.resolve(false);
  return http.post(ROTA, { motivo: resultado.motivo, origem })
    .then(() => true)
    .catch(() => false);
}
